import type { BaseFieldObject } from '@noths/polaris-dev-ts-types';

type EventCategory = 'Rich Relevance' | 'Product listings' | 'Featured Product';

export type ProductClickTrackingEvent = {
  event: 'product_clicks';
  event_category: EventCategory;
  event_action: 'Product Click';
  event_label: string;
  destination_URL?: string;
  algonomy_tracking_URL?: string;
  ecommerce: {
    click: {
      actionField: {
        list: string;
      };
      products: BaseFieldObject[];
    };
  };
};

interface GetProductClickTrackingEventArgs {
  eventCategory: EventCategory;
  eventLabel: string;
  destinationUrl?: string;
  recommendationsTrackingUrl?: string;
  actionFieldList: string;
  products: BaseFieldObject[];
}

export const getProductClickTrackingEvent = ({
  eventCategory,
  eventLabel,
  destinationUrl,
  recommendationsTrackingUrl,
  actionFieldList,
  products,
}: GetProductClickTrackingEventArgs): ProductClickTrackingEvent => {
  return {
    event: 'product_clicks',
    event_category: eventCategory,
    event_action: 'Product Click',
    event_label: eventLabel,
    ...(destinationUrl ? { destination_URL: destinationUrl } : {}),
    ...(recommendationsTrackingUrl ? { algonomy_tracking_URL: recommendationsTrackingUrl } : {}),
    ecommerce: {
      click: {
        actionField: {
          list: actionFieldList,
        },
        products,
      },
    },
  };
};
